// extracted by mini-css-extract-plugin
export default {"messageInput":"TextAreaInput_messageInput__1xjLf","short":"TextAreaInput_short__EZQLd","medium":"TextAreaInput_medium__00pWh","long":"TextAreaInput_long__zl8Kn"};